export const getColorFromDistance = (distance: number) => {
    if (distance <= 1) return "#00FF00"; // Bright Green
    if (distance <= 3) return "#FFFF00"; // Bright Yellow
    return "#FF0000"; // Bright Red
};

export default getColorFromDistance;
